import { action, makeObservable, observable } from 'mobx';
import { RootStore } from './RootStore';
import { IClid } from '../services/solgari-api/interfaces/outbound-clid.interface';
import { SolgariApiService } from '../services/solgari-api/solgari-api.service';
import { logger } from '../services/logger.service';

class ClidStore {
  @observable
  availableClids: IClid[] = [];

  @observable
  selectedClid: IClid | null = null;

  @observable
  isLoading: boolean = false;

  @observable
  error: string | null = null;

  constructor(public root: RootStore) {
    makeObservable(this);
  }

  @action
  setAvailableClids = (clids: IClid[]) => {
    this.availableClids = clids;
  };

  @action
  setSelectedClid = (clid: IClid | null) => {
    this.selectedClid = clid;
  };

  @action
  setLoading = (loading: boolean) => {
    this.isLoading = loading;
  };

  @action
  setError = (error: string | null) => {
    this.error = error;
  };

  @action
  fetchAvailableClids = async () => {
    try {
      this.setLoading(true);
      this.setError(null);

      const clidResponse = await SolgariApiService.getOutboundClids();

      if (clidResponse?.clids?.length > 0) {
        this.setAvailableClids(clidResponse.clids);
        const selectedClid = clidResponse.clids.find((clid) => clid.isSelected);
        if (selectedClid) {
          this.setSelectedClid(selectedClid);
        }
      }
    } catch (error) {
      logger.error('Failed to fetch available CLIDs:', error);
      this.setError('Failed to load available caller IDs');
    } finally {
      this.setLoading(false);
    }
  };

  @action
  selectClid = async (clid: IClid) => {
    try {
      this.setLoading(true);
      this.setError(null);

      await SolgariApiService.setOutboundClids(clid);

      this.setAvailableClids(
        this.availableClids.map((c) => ({
          ...c,
          isSelected: c.clidId === clid.clidId,
        })),
      );

      this.setSelectedClid(clid);
    } catch (error) {
      logger.error('Failed to select CLID:', error);
      this.setError('Failed to update caller ID');
    } finally {
      this.setLoading(false);
    }
  };
}

export default ClidStore;
